import React from 'react'
import { useHistory } from 'react-router-dom';


const Success = () => {

    const history = useHistory();

    const viewServices = () => {
        history.push(`/farmer/farm/equipment`)
    }

    const viewEquipments = () => {
        history.push(`/farmer/farm/equipment/view`)
    }
    return (
        <div className="content-wrapper">
            <div className="container-fluid">
                <div>
                    <div class="success-checkmark">
                        <div class="check-icon">
                            <span className="icon-line line-tip"></span>
                            <span className="icon-line line-long"></span>
                            <div className="icon-circle"></div>
                            <div className="icon-fix"></div>
                        </div>
                    </div>
                    <div className="mb-5"><p className="success-msg"><strong>Service booked successfully,
                    A confirmation email has been sent to you</strong></p></div>
                    
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <div className="mt-5 mx-5 w-50">
                            <button type='submit' onClick={viewServices} className="btn btn-success btn-sm btn-block text-white">View more services</button>
                        </div>
                        <div className="mt-5 mx-5 w-50">
                            <button type='submit' onClick={viewEquipments} className="btn btn-success btn-sm btn-block text-white">View equipment bookings</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Success
